export const locale = {
    lang: 'en',
    data: {
        MENU: {
            DASHBOARD: 'Dashboard',
            PRODUCTS: 'Products',
            PACKAGES: 'Packages',
            STOCKS: {
                COLLAPSIBLE: 'Stocks',
                MY_PRODUCTS: 'My Products',
                MY_ORDERS: 'My Orders'
            },
            USERS: {
                COLLAPSIBLE: 'Users',
                PRODUCT_ORDERS: 'Product Orders',
                PACKAGE_ORDERS: 'package Orders'
            },
            SUPPORT_TICKETS: 'Support Tickets',
            SALES_INCOME: 'Sales Income'
        }
    }
};
